import { Box, Stack } from '@mui/material';
import { DataGridProvider } from '@issuemanager/apps/client/components';
import { ISSUES_GRID_KEY } from '@issuemanager/apps/client/utils';
import { useTranslation } from 'react-i18next';
import { useSetHeaderProps } from '@issuemanager/apps/client/contexts';
import { useEffect } from 'react';
import { IssueGrid } from '../components/issue-grid';

export default function () {
  const { t } = useTranslation();

  const setHeaderProps = useSetHeaderProps();

  useEffect(() => {
    setHeaderProps({ viewTitle: { title: t('appName') } });
  }, []);

  return (
    <Box px={4} py={4}>
      <Stack spacing={4}>
        <DataGridProvider storageKey={ISSUES_GRID_KEY}>
          <IssueGrid />
        </DataGridProvider>
      </Stack>
    </Box>
  );
}
